import { useState } from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function EnquiryForm({ endpoint, fields, title, successMsg, testid }) {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    for (const f of fields) {
      if (f.required && !form[f.name]) return toast.error(`${f.label} is required`);
    }
    setLoading(true);
    try {
      await api.post(endpoint, form);
      setDone(true);
      toast.success(successMsg || "Enquiry sent");
    } catch {
      toast.error("Something went wrong, try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) return (
    <div className="border border-[#ff7a1a]/40 bg-[#121212] p-10 text-center" data-testid={`${testid}-success`}>
      <CheckCircle2 className="mx-auto text-[#ffd600] mb-4" size={44} />
      <h3 className="font-heading text-2xl text-white uppercase">Enquiry received</h3>
      <p className="text-[#8a8d91] mt-2">Thanks. Our team will be in touch shortly.</p>
    </div>
  );

  return (
    <form onSubmit={submit} className="space-y-4 border border-white/10 bg-[#121212] p-6 sm:p-8" data-testid={testid}>
      {title && <h3 className="font-heading text-xl uppercase text-white mb-2">{title}</h3>}
      {fields.map((f) => (
        f.type === "textarea" ? (
          <textarea key={f.name} data-testid={`${testid}-${f.name}`} rows={4} placeholder={f.label + (f.required ? "" : " (optional)")}
            value={form[f.name] || ""} onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
            className="w-full bg-[#0f0f11] border border-white/15 px-4 py-3 text-white outline-none focus:border-[#b026ff]" />
        ) : f.type === "select" ? (
          <select key={f.name} data-testid={`${testid}-${f.name}`} value={form[f.name] || ""} onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
            className="w-full bg-[#0f0f11] border border-white/15 px-4 py-3 text-white outline-none focus:border-[#b026ff]">
            <option value="">{f.label}</option>
            {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        ) : (
          <input key={f.name} data-testid={`${testid}-${f.name}`} type={f.type || "text"} placeholder={f.label + (f.required ? "" : " (optional)")}
            value={form[f.name] || ""} onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
            className="w-full bg-[#0f0f11] border border-white/15 px-4 py-3 text-white outline-none focus:border-[#b026ff]" />
        )
      ))}
      <button disabled={loading} className="pas-btn w-full text-base" data-testid={`${testid}-submit`}>
        {loading ? "Sending..." : "Send enquiry"} <ArrowRight size={18} />
      </button>
    </form>
  );
}
